import { Controller, Payload } from "../../controller";
import { ApplicationState } from "../../store";
import { bindActionCreators, Dispatch } from "redux";
import { Fornecedor ,initialValueState, FornecedorState, FornecedorActions } from "./forn.model"

export interface FornecedorViewProps{
    fornecedorState:FornecedorState
    fornecedorActions:FornecedorActions
}

class FornecedorController extends Controller<Fornecedor, FornecedorState, FornecedorActions> {
    constructor() {
        super(initialValueState.row.type,initialValueState);

        this.actionsType = {
            ...this.actionsType,
            //inserir aqui os novos actionsTypes
        };

        this.reducer.actions = {
            ...this.reducer.actions,
            //inserir aqui os novos actions
        }

        this.actionEffects = [
            ...this.actionEffects,
            //inserir aqui os novos Effects
        ]
    }

    private* novoActionEffects(actions:Payload){

    }
}

export const fornecedorController = new FornecedorController()

export const mapStateToFornecedorProps = (state: ApplicationState) => ({
    fornecedorState: state.fornecedorState,
})

export const mapDispatchToFornecedorProps = (dispatch: Dispatch) => ({
    fornecedorActions: bindActionCreators({...fornecedorController.reducer.actions}, dispatch),
})